'use strict';

const PoolCluster = require('./pool_cluster.js');

function createPoolCluster(config) {
  return new PoolCluster(config);
}

module.exports = createPoolCluster;
